export default "__VITE_ASSET__c272e43d__"